export default __webpack_public_path__ + "static/zaru_collages_v6-11-32100ee8c7646716477e78a5a7939659.png";